<template>
    <div class="layer-content common">
    	<!-- 개인정보의 제3자 제공 -->
		<div class="term-box">
			<div class="term-tit1">1. 개인정보 3자 제공</div>
            <ol>
				<li>① ‘회사’는 정보주체의 개인정보를 제1조(개인정보의 처리 목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다.</li>
				<li>② ‘회사’는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다.
					<table class="tb-col mgt20">
						<colgroup>
							<col style="width:25%" span="4">
						</colgroup>
						<thead>
						<tr>
							<th>제공받는 자</th>
							<th>이용목적</th>
							<th>제공항목</th>
							<th>보유기간</th>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td rowspan="2">㈜온앤온정보<br>시스템</td>
							<td>시스템 유지보수,<br>고객상담</td>
							<td>교직원(성명, <br>연락처, 생년월일),<br />원아(아동명, <br>생년월일, 성별, <br>보호자휴대폰번호)</td>
							<td rowspan="2">서비스 계약에 따른 <br>사용 기간동안</td>
						</tr>
						<tr>
							<td>등하원 서비스 <br>제공</td>
							<td>출결 인식 리더기 <br>설치 위치,<br> 원아 출결시간</td>
						</tr>
						</tbody>
					</table>
				</li>
			</ol>

			<div class="term-tit1">2. 개인정보처리의 위탁</div>
			<ol>
				<li>① ‘회사’는 원활한 개인정보 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있습니다.
               		<table class="tb-col mgt20">
		                <colgroup>
		                    <col style="width:30%">
		                    <col style="width:*">
		                </colgroup>
		                <thead>
		                <tr>
		                    <th>위탁받는 자</th>
		                    <th>업무 내용</th>
		                </tr>
		                </thead>
		                <tbody>
		                <tr>
		                    <td>㈜이니시스</td>
		                    <td>월 서비스 요금 결제</td>
		                </tr>
		                <tr>
		                    <td>CJ대한통운</td>
		                    <td>물품 배송 서비스</td>
		                </tr>
		                <tr>
		                    <td>LG유플러스</td>
		                    <td>SMS, MMS 발송</td>
		                </tr>
		                </tbody>
		            </table>
               	</li>
				<li>② ‘회사’는 위탁계약 체결 시 개인정보 보호법 제25조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적․관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리․감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
				<li>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
            </ol>
		</div>
	</div>
</template>
    
<script>
    export default {
        name : 'ptoAgreePopup',
        data : function(){
            return {
            }
        },
        methods: {
        },
    }
</script>